import { Toast } from "primereact/toast"
import { useRef, useState } from "react"
import { Form } from "./Form"
import { Table } from "./Table"

export interface IEscalationStatus {
    id?: string,
    status?: string,
    active?: boolean,
    created_By?: string,
    created_At?: Date,
    updated_By?: string,
    updated_At?: Date
}

export interface IModel {
    open: boolean,
    singleData: IEscalationStatus
}

export const StatusMaster = () => {
    const [reLoad, setReLoad] = useState(false);
    const [modal, setModal] = useState({ singleData: { status: "", active: true }, open: false } as IModel);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: { status: "", active: true }, open: false });
    }

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} setReLoad={() => setReLoad(!reLoad)} />
            <Table setModal={setModal} toast={toast} reLoad={reLoad} />
            <Toast ref={toast} />
        </>
    );
}